module.exports = __webpack_public_path__ + "static/media/logo.167ef4ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 490
// module chunks = 0